import { FormConfigBase } from './abstract/form-config-base.class';
import { InputModel } from './input.model';
import { ChipsInterface } from '../interfaces/chips.interface';

export class ChipsModel extends FormConfigBase {
  input: InputModel;
  codes: string[];
  requiredText?: string;

  constructor( obj: ChipsInterface ) {
    super( obj );

    this.codes = obj && obj.codes && obj.codes.length > 0 ? obj.codes : [];
    this.requiredText = obj && obj.requiredText ? obj.requiredText : '';
    this.input = new InputModel( obj && obj.input ? obj.input : null );
  }
}
